import { waitForMs } from '../../helpers';

export default () => {
  if ($('.references-banner').length > 0) {
    const json = JSON.parse($('#reference-banner-feedbacks-data').text());
    // console.log(json);
    let refIdx = 1;

    const feedbackAvatarPlaceholder = $('#feedback-avatar-placeholder').val();

    setInterval(async () => {
      $('.references-banner-feedbacks__container').addClass('changing');
      await waitForMs(500);
      const { avatar, brandLogo, comment, fullname, position } = json[refIdx];

      $('.references-banner-person__avatar').attr(
        'src',
        avatar ? avatar : feedbackAvatarPlaceholder
      );

      $('.references-banner__brand > div').attr(
        'style',
        `--img-src:url(${brandLogo})`
      );
      $('.references-banner-feedbacks__text').html(comment);
      $('.references-banner-person__name').text(fullname);
      $('.references-banner-person__job-title').text(position);

      $('.references-banner-feedbacks__container').removeClass('changing');
      await waitForMs(500);

      refIdx = refIdx + 1 < json.length ? refIdx + 1 : 0;
    }, 7000);

    // console.log($('#reference-banner-feedbacks-data').text());
  }
};
